import { Link } from "react-router-dom";
import LegalLayout from "@/components/legal/LegalLayout";

const TOC = [
  { id: "seller", label: "Seller details" },
  { id: "products", label: "What we sell" },
  { id: "payments", label: "Payments and taxes" },
  { id: "policies", label: "Our policies" },
  { id: "commitments", label: "Our commitments" },
  { id: "grievance", label: "Complaints and Grievance Officer" },
];

export default function SellerInformationPage() {
  return (
    <LegalLayout title="Seller Information" activePath="/seller-information" toc={TOC}>
      <section className="tc__sec" id="seller">
        <h2>Seller details</h2>
        <p>This store is run by an individual, not a company. In line with India's Consumer Protection (E-Commerce) Rules, 2020, here are the seller's details:</p>
        <div className="tc__card">
          <p><strong>Seller:</strong> Rajesh Nuthalapati, an individual seller</p>
          <p><strong>Publishing as:</strong> Rajesh Sivacharya</p>
          <p><strong>Address for notices:</strong> Flat No. 409, Thatipalli Lake View Apartments, 4th Floor, Priyadarshini Colony, Paloncha Town, Bhadradri Kothagudem District, Telangana – 507115</p>
          <p><strong>Customer support:</strong> <a href="mailto:support@rajeshsivacharya.com">support@rajeshsivacharya.com</a></p>
          <p><strong>Support hours:</strong> Monday to Friday, 10:00 to 18:00 IST</p>
          <p><strong>Website:</strong> rajeshsivacharya.com</p>
        </div>
      </section>

      <section className="tc__sec" id="products">
        <h2>What we sell</h2>
        <p>Digital products only: books, guided journals and practice kits, delivered as PDF downloads by email immediately after payment. No physical goods are shipped. Each product page states its contents, format and length.</p>
      </section>

      <section className="tc__sec" id="payments">
        <h2>Payments and taxes</h2>
        <p>Payments are processed by <strong>Dodo Payments</strong>, which acts as Merchant of Record: it processes your payment securely, collects any applicable taxes (GST, VAT or sales tax), and appears on your card or bank statement. Prices shown on the Website include all applicable taxes. We never see or store your card details.</p>
      </section>

      <section className="tc__sec" id="policies">
        <h2>Our policies</h2>
        <ul>
          <li><Link to="/terms">Terms and Conditions</Link>: the agreement for using this Website and buying our products.</li>
          <li><Link to="/privacy">Privacy Policy</Link>: how we handle your personal data under the DPDP Act, 2023, GDPR and US privacy laws.</li>
          <li><Link to="/refund-policy">Refund Policy</Link>: how to request a refund and the time limits that apply.</li>
          <li><Link to="/disclaimer">Disclaimer</Link>: our content is education, not financial, medical or professional advice.</li>
        </ul>
      </section>

      <section className="tc__sec" id="commitments">
        <h2>Our commitments</h2>
        <ul>
          <li><strong>Honest pricing:</strong> the price you see is the price you pay. No hidden charges, no fake discounts, no false countdown timers or scarcity claims.</li>
          <li><strong>Real reviews:</strong> testimonials come from real readers, with permission. Any free copy or benefit given to a reviewer is disclosed.</li>
          <li><strong>No outcome promises:</strong> we do not guarantee financial, health or personal results.</li>
          <li><strong>Your data:</strong> we collect only what is needed, never sell it, and email you only with your consent.</li>
          <li><strong>Accessibility:</strong> we aim to meet WCAG 2.1 AA. If anything on this Website is hard to use, please tell us and we will help.</li>
        </ul>
      </section>

      <section className="tc__sec" id="grievance">
        <h2>Complaints and Grievance Officer</h2>
        <p>We acknowledge every complaint within 48 hours and resolve it within one month of receipt.</p>
        <div className="tc__card">
          <p><strong>Grievance Officer:</strong> Rajesh Nuthalapati</p>
          <p><strong>Email:</strong> <a href="mailto:support@rajeshsivacharya.com">support@rajeshsivacharya.com</a></p>
          <p><strong>Address:</strong> Flat No. 409, Thatipalli Lake View Apartments, 4th Floor, Priyadarshini Colony, Paloncha Town, Bhadradri Kothagudem District, Telangana – 507115</p>
          <p><strong>Hours:</strong> Monday to Friday, 10:00 to 18:00 IST</p>
        </div>
        <p>If you are in India and your complaint is not resolved, you can contact the National Consumer Helpline (1915, or consumerhelpline.gov.in) or, for personal data matters, the Data Protection Board of India.</p>
      </section>
    </LegalLayout>
  );
}
